<template>
  <v-menu
    :close-on-content-click="false"
    v-model="menuOpened"
    :nudge-width="450"
    max-width="600"
    transition="scale-transition"
  >
    <template v-slot:activator="{ on }">
      <v-tooltip top>
        <template v-slot:activator="{ on: onTooltip }">
          <v-btn icon
                 v-on="{ ...onTooltip, ...on }"
                 @click.stop.prevent=""
          >
            <v-icon :color="iconColor">mdi-filter-outline</v-icon>
          </v-btn>
        </template>
        <span>Filtrar por</span>
      </v-tooltip>
    </template>
    <v-card>
      <v-card-text class="text--primary">
        <v-row dense class="mt-1">
          <v-col cols="12">
            <px-autocomplete-estados-multiple
              class="rounded-tag-small"
              dense
              v-model="estados"/>
          </v-col>
        </v-row>
        <v-row dense class="mt-1">
          <v-col cols="12">
            <px-autocomplete-municipios-multiple
              dense
              class="rounded-tag-small"
              :ufs="estados"
              v-model="municipios"/>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions class="pa-3">
        <v-btn color="primary"
               class="normal-btn-text rounded-tag-small elevation-0"
               @click="emitChange">
          Aplicar
        </v-btn>
        <v-btn text class="normal-btn-text" @click="clearFilters">
          Limpar filtros
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
import PxAutocompleteEstadosMultiple from './autocompletes/PxAutocompleteEstadosMultiple.vue';
import PxAutocompleteMunicipiosMultiple from './autocompletes/PxAutocompleteMunicipiosMultiple.vue';

export default {
  data: () => ({
    menuOpened: false,
    estados: [],
    municipios: [],
  }),
  computed: {
    hasCustomFilters() {
      return [
        this.estados && this.estados.length,
        this.municipios && this.municipios.length,
      ].some(v => !!v);
    },
    iconColor() {
      return this.hasCustomFilters ? 'primary' : '';
    },
  },
  methods: {
    emitChange() {
      this.$emit('change', {
        estados: this.estados ?? [],
        municipios: this.municipios ?? [],
      });
      this.close();
    },
    clearFilters() {
      this.estados = [];
      this.municipios = [];
      this.emitChange();
    },
    close() {
      this.menuOpened = false;
    },
  },
  components: {
    PxAutocompleteEstadosMultiple,
    PxAutocompleteMunicipiosMultiple,
  },
};
</script>
